/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import MaxLengthNumericEditor from '../../../../SharedModules/CustomAgGridEditor/inputComponent';
import * as Styles from './StyleConstant';
import CheckBoxRender from '../../../System/priceType/components/checkBoxRender';

export const hideColumns = ['action'];
export const DrugsNameHeader = [
  {
    headerName: 'Actions',
    field: hideColumns[0],
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    maxWidth: Styles.Width_90,
    cellEditor: MaxLengthNumericEditor,
    sortingOrder: ['desc', 'asc'],
    maxLength: Styles.Length_10,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'ActionCellRender',
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    suppressMenu: false,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_150,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    cellClass: 'ag-cell-action',
    cellEditorPopup: true,
    cellRenderer: 'ndcLinkRender',
  },
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    suppressMenu: false,
    cellEditor: MaxLengthNumericEditor,
    minWidth: Styles.Width_300,
    maxLength: Styles.Length_30,
    cellStyle: { borderRightColor: Styles.BorderColor },
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
  },
];

export const DrugFamilyHeader = [
  {
    headerName: 'Actions',
    field: hideColumns[0],
    editable: false,
    sortable: false,
    filter: false,
    suppressMenu: false,
    maxWidth: Styles.Width_90,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'ActionCellRender',
  },
  {
    headerName: 'Family ID',
    field: 'family',
    editable: false,
    sortable: true,
    sort: 'asc',
    sortingOrder: ['desc', 'asc'],
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressMenu: false,
    minWidth: Styles.Width_150,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'ndcLinkRender',
  },
  {
    headerName: 'Family Name',
    field: 'familyName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressMenu: false,
    minWidth: Styles.Width_200,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'IconButtonCell',
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'Brand Name',
    field: 'brandName',
    editable: false,
    sortable: true,
    columnSpan: 3,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressMenu: false,
    minWidth: Styles.Width_250,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'IconButtonCell',
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: '',
    field: '',
    removeColumn: true,
    minWidth: 1,
    resizable: false,
    editable: false,
  },
  {
    headerName: 'STC',
    field: 'stc',
    editable: false,
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    suppressMenu: false,
    minWidth: Styles.Width_100,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'IconButtonCell',
  },
];

export const TherapeucticHeader = [
  {
    headerName: 'Therapeutic Class CD',
    field: 'classCd',
    editable: false,
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    maxWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'ActionCellRender',
  },
  {
    headerName: 'Description',
    field: 'description',
    editable: false,
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    maxWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'IconButtonCell',
  },
];

export const TherapeuticRows = [{ classCd: 'H2D', description: ' ' }];

export const DrugFamilyDetailsHeader = [
  {
    headerName: 'Drug Name',
    field: 'drugName',
    editable: false,
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_10,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'DrugNameRenderer',
  },
  {
    headerName: 'NDC',
    field: 'ndc',
    editable: false,
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'LinkNdcButton',
  },
  {
    headerName: 'Start Date',
    field: 'startDate',
    editable: false,
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'startDateCell',
  },
  {
    headerName: 'End Date',
    field: 'endDate',
    editable: false,
    sortable: true,
    filter: 'agTextColumnFilter',
    filterParams: {
      defaultOption: 'startsWith',
      suppressAndOrCondition: true,
      buttons: ['reset'],
      refreshValuesOnOpen: true,
    },
    minWidth: Styles.Width_300,
    cellEditor: MaxLengthNumericEditor,
    maxLength: Styles.Length_30,
    cellClass: 'ag-cell-action',
    cellStyle: { borderRightColor: Styles.BorderColor },
    cellEditorPopup: true,
    cellRenderer: 'endDateCell',
  },
];

export const DrugFamilyDetailsRows = [
  {
    drugName: '',
    ndc: '',
    startDate: '',
    endDate: ' ',
  },
];
